import { render, staticRenderFns } from "./CollegeListSpecialty.vue?vue&type=template&id=944e9f12&scoped=true"
import script from "./CollegeListSpecialty.vue?vue&type=script&lang=js"
export * from "./CollegeListSpecialty.vue?vue&type=script&lang=js"
import style0 from "./CollegeListSpecialty.vue?vue&type=style&index=0&id=944e9f12&prod&scoped=true&lang=less"
import style1 from "./CollegeListSpecialty.vue?vue&type=style&index=1&id=944e9f12&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "944e9f12",
  null
  
)

export default component.exports